/*
 * @Date: 2021-05-12 09:27:27
 */
export default {
	state: {
		curThemeType: 'cnWrap',
	},
	getters: {
		getCurThemeType(state) {
			return state.curThemeType
		},
	},
	mutations: {
		setCurThemeType(state, data) {
      // debugger
			state.curThemeType = data
		},

	
	},
}
